export interface PromoBanner {
  id?: string;
  title: string;
  subTitle: string;
  linkLabel: string;
  link: string;
  validUntil: string; // ISO string
  orderNumber: number;
}
